import { useMemo } from "react";
import { useStore } from 'react-redux';
import { createAction } from "./redux/actions";
import { v4 } from "uuid";

export const useDataProviderRoot = () => {
    const store = useStore();

    const discover = (id) => {
        if (!id) return null;

        const state = store.getState();

        let result;
        for (const container in state) {
            //console.info('CICLO ', container, state[container], 'cercando', id);
            if (state[container]?.global?.items?.[id]) {
                result = state[container].global.items[id];
                break;
            }
        }
        
        return result;
    }

    return {
        discover
    }
}
